<script>
  import { MainForm, Advantages, HowWeWork, Faq, ReviewsSlider, Button, Services, store, imgSrc } from '$client';
  import { replaceKeys } from '$client';
  export let data;
  const { city } = store;
  $: service = data.service;
  $: reviews = data.reviews;
</script>

<section id="main" class="margin-block">
  <section itemscope itemtype="http://schema.org/Product" class="container">
    <div>
      <img
        height={service.pageImg.data.attributes.height}
        width={service.pageImg.data.attributes.width}
        itemprop="image"
        src={imgSrc(service.pageImg.data.attributes.url)}
        alt={service.pageImg.data.attributes.alternativeText} />
      {#if !service.price}
        <b>Бесплатно</b>
      {/if}
    </div>

    <div>
      <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
        <meta itemprop="ratingValue" content="4.6" />
        <meta itemprop="bestRating" content="5" />
        <meta itemprop="ratingCount" content="45" />
        <div itemprop="itemReviewed" itemscope itemtype="https://schema.org/ProfessionalService">
          <meta itemprop="name" content="{service.header} г. {$city.header}" />
          <meta itemprop="image" content={imgSrc(service.pageImg.data.attributes.url)} />
          <meta itemprop="telephone" content={$city.phone} />
          <meta itemprop="address" content={$city.office} />
        </div>
      </div>
      <h1 itemprop="name" class="h1">{service.header} <br /> г. {$city.header}</h1>
      <p itemprop="description"><span>Описание: </span>{@html replaceKeys($city, service.description)}</p>
      <p itemprop="offers" itemscope itemtype="http://schema.org/Offer">
        <strong>Цена: {!service.price ? 'Бесплатно' : service.price + '₽'}</strong>
        <meta itemprop="price" content={service.price} />
        <meta itemprop="priceCurrency" content="RUB" />
        <link itemprop="availability" href="http://schema.org/InStock" />
        <!-- 
        ? Microdata for shipping <May not be useful>
        <span itemprop="shippingDetails" itemtype="https://schema.org/OfferShippingDetails" itemscope>
          <div itemprop="shippingRate" itemtype="https://schema.org/MonetaryAmount" itemscope>
            <meta itemprop="value" content="0" />
            <meta itemprop="currency" content="RUB" />
          </div>
          <div itemprop="shippingDestination" itemtype="https://schema.org/DefinedRegion" itemscope>
            <meta itemprop="addressCountry" content="RU" />
          </div>
          <div itemprop="deliveryTime" itemtype="https://schema.org/ShippingDeliveryTime" itemscope>
            <div itemprop="handlingTime" itemtype="https://schema.org/QuantitativeValue" itemscope>
              <meta itemprop="minValue" content="0" />
              <meta itemprop="maxValue" content="1" />
              <meta itemprop="unitCode" content="HOUR" />
            </div>
            <div itemprop="transitTime" itemtype="https://schema.org/QuantitativeValue" itemscope>
              <meta itemprop="minValue" content="1" />
              <meta itemprop="maxValue" content="24" />
              <meta itemprop="unitCode" content="HOUR" />
            </div>
          </div>
        </span> -->
      </p>
      <div itemprop="brand" itemtype="https://schema.org/Brand" itemscope>
        <meta itemprop="name" content="uberi" />
      </div>
      {#if service.button[0]}
        <Button action={service.button[0].href ?? service.button[0].modal} title={service.button[0].header} />
      {/if}
    </div>
  </section>
  {#if service.firstTextBlock}
    <section class="advantages margin-top container">
      <h2 class="h2">{service.firstTextBlock.header}</h2>
      {#if service.firstTextBlock.data}
        <div class="custom-page">{@html service.firstTextBlock.data}</div>
      {/if}
    </section>
  {/if}
  <section class="container advantages margin-block">
    <h2 class="h2">{service.advantages.header}</h2>
    <Advantages data={service.advantages.data} />
  </section>
  <HowWeWork data={service.howWeWork} />
  <MainForm data={service.form.data.attributes} />
  <footer>
    <Services data={service.services} />
  </footer>
  {#if service.secondTextBlock}
    <section class="advantages margin-top container">
      <h2 class="h2">{service.secondTextBlock.header}</h2>
      {#if service.secondTextBlock.data}
        <div class="custom-page">{@html service.secondTextBlock.data}</div>
      {/if}
    </section>
  {/if}
  <ReviewsSlider type="white" data={reviews} />
  <Faq data={service.faq.data.attributes} />
</section>

<style lang="scss">
  #main {
    :global(.faq) {
      margin-top: 55px;

      @media only screen and (max-width: 767.98px) {
        margin-top: 45px;
      }
    }
  }

  #main > section:first-child {
    position: relative;
    display: inline-flex;
    gap: 40px;
    align-items: flex-start;
    justify-content: flex-start;

    > div {
      position: relative;
      width: 50%;

      > b {
        position: absolute;
        top: 14px;
        left: 14px;
        padding: 4px 8px;
        color: #2c333c;
        font-weight: bold;
        font-size: 20px;
        font-family: Vela Sans;
        font-style: normal;
        line-height: 140%; /* 28px */
        background: #22eaac;
        border-radius: 100px;
      }
    }

    img {
      width: 100%;
      height: 480px;
      object-fit: cover;
      border-radius: 15px;
      aspect-ratio: 21 / 9;

      @media only screen and (max-width: 767.98px) {
        max-height: 350px;
      }
    }

    @media only screen and (max-width: 1199.98px) {
      :global(button),
      :global(a) {
        padding: 18px 40px;
      }
    }

    h1 {
      color: #2c333c;
      font-weight: 800;
      font-family: Vela Sans;
      font-style: normal;
    }

    p {
      display: flex;
      flex-direction: column;
      color: #2c333c;
      font-weight: normal;
      font-size: 16px;
      font-family: Roboto;
      font-style: normal;
      line-height: 140%; /* 25.2px */

      span {
        color: #2c333c;
        font-weight: 500;
        font-size: 16px;
        font-family: Vela Sans;
        font-style: normal;
        line-height: 140%; /* 22.4px */
      }

      @media only screen and (max-width: 1199.98px) {
        font-size: 14px;
      }
    }

    :global(button),
    :global(a) {
      margin-top: auto;
    }

    strong {
      color: #2c333c;
      font-weight: 800;
      font-size: 32px;
      font-family: Vela Sans;
      font-style: normal;
      line-height: 130%; /* 46.8px */
      letter-spacing: 0.36px;

      @media only screen and (max-width: 1199.98px) {
        font-size: 28px;
      }
    }

    div {
      display: flex;
      flex-direction: column;
      gap: 20px;
      align-items: flex-start;
      justify-content: flex-start;

      @media only screen and (max-width: 575.98px) {
        align-items: center;
      }
    }

    @media only screen and (max-width: 991.98px) {
      flex-direction: column;

      img,
      div {
        width: 100%;
      }

      p {
        font-size: 16px;
      }
    }
  }

  .advantages h2 {
    margin-bottom: 50px;
    color: #2c333c;
    font-weight: 800;
    font-family: Vela Sans;

    @media only screen and (max-width: 575.98px) {
      text-align: center;
    }
  }
</style>
